import { createSelector } from 'reselect';
import { ReduxStore } from '../interfaces/store';

const root = (store: ReduxStore) => store.app;

export const localizationSelector = createSelector(
  root,
  root => root?.localization
);
